import {
  BankOutlined,
  BarChartOutlined,
  SwapOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import React from 'react';

const resizeIcon = (Icon) => <Icon style={{ fontSize: '16px' }} />;

export const PLATFORM_SIDEBAR_ITEMS = [
  {
    route: { path: '/platform/clients' },
    label: 'Clients',
    icon: resizeIcon(TeamOutlined),
  },
  {
    route: { path: '/platform/reporting' },
    label: 'Reporting',
    icon: resizeIcon(BarChartOutlined),
  },
  {
    route: { path: '/console' },
    label: 'Open Console',
    icon: resizeIcon(SwapOutlined),
    bottom: true,
  },
];

export const CONSOLE_PLATFORM_SWITCH = {
  route: { path: '/platform/clients' },
  label: 'Platform',
  icon: resizeIcon(BankOutlined),
  bottom: true,
  superuserOnly: true,
};
